import { DATA_CENTERS, LatencyDetails } from '../../constants';
import { checkDataCenterLatency } from "./client";

export const REQUIRED_SAMPLES = 7;
export const MAX_ACCEPTABLE_LATENCY = 150;

async function getRegionSampleLatencies(): Promise<LatencyDetails[]> {
  let regionList: LatencyDetails[] = [];
  // throw away first sample for each
  console.log('==BEGIN REGION LATENCY SAMPLES==');
  for (const dataCenter of DATA_CENTERS) {
    let iteration = 0;
    while (iteration <= REQUIRED_SAMPLES) {
      const res = await checkDataCenterLatency(dataCenter.url);
      // if cannot get response, break loop and throw out samples for this region
      if (res === null) {
        console.error(`Failed to receive required samples for ${dataCenter.displayName}`);
        regionList = regionList.filter((r) => r.dataCenter.id !== dataCenter.id);
        break;
      }
      // if iteration is 0, skip adding the responses its only purpose is for dns resolution
      if (iteration > 0) {
        console.info(`%c ${res.data.duration}ms`, 'margin-left: 5px');
        regionList.push({
          dataCenter: dataCenter,
          duration: res.data.duration,
          isPassing: res.data.duration <= MAX_ACCEPTABLE_LATENCY,
        });
      } else {
        console.log(`${dataCenter.displayName} Latencies:`);
      }
      iteration++;
    }
  }
  return regionList;
}

function findRegionWithBestMedianSample(regionList: LatencyDetails[]): LatencyDetails | null {
  let lowestMedianLatencyRegion: LatencyDetails | null = null;
  console.log('==REGION MEDIAN LATENCIES==');
  for (const {id, displayName} of DATA_CENTERS) {
    const regionSamples = regionList
      .filter((r) => r.dataCenter.id === id)
      .sort((a, b) => {
        return a.duration > b.duration ? 1 : -1;
      });

    if (regionSamples.length < REQUIRED_SAMPLES) {
      continue;
    }
    // remove highest two responses to account for potential high outliers
    regionSamples.splice(-2, 2);
    const medianIndex = Math.floor(regionSamples.length / 2);
    const medianSample = regionSamples[medianIndex];
    console.log(
      `%c Median latency:  ${displayName}: ${medianSample.duration}ms`,
      `color: ${medianSample.duration > MAX_ACCEPTABLE_LATENCY ? 'red' : 'green'}; font-weight: 700 `
    );

    if (!lowestMedianLatencyRegion || medianSample.duration < lowestMedianLatencyRegion.duration) {
      lowestMedianLatencyRegion = medianSample;
    }
  }
  console.log(
    `%c Best Median Latency:  ${lowestMedianLatencyRegion?.dataCenter.displayName}: ${lowestMedianLatencyRegion?.duration}ms`,
    `font-weight: 700`
  );
  return lowestMedianLatencyRegion;
}

export async function getClosestRegion(): Promise<LatencyDetails | null> {
  const regionList = await getRegionSampleLatencies();

  // if length is 0, return null to let React component know that no region completed all required latency samples
  if (!regionList.length) {
    return null;
  }

  // Find best median latency
  return findRegionWithBestMedianSample(regionList);
}
